<template>
    <div class="success-container">

        <div class="form-ct">
            <h4 style="font-size: 18px;margin-left: 10px;color: white;">订单提交成功</h4>

            <div class="form">
                <div class="success-message">
                    <van-icon name="success" size="60px" color="#07c160" />
                    <h3 style="color: white;margin: 20px 0;">订单提交成功！</h3>
                    <p style="color: rgba(255, 255, 255, 0.8);">您的套餐已成功提交，我们将尽快为您配送。</p>
                </div>

                <!-- 已选择的套餐信息 -->
                <div class="selected-package" v-if="selectedPackage">
                    <h4 style="color: white;margin: 20px 0 10px;">您选择的套餐</h4>
                    <div class="package-info">
                        <img :src="selectedPackage.image" :alt="selectedPackage.name" class="package-image">
                        <div class="package-details">
                            <h5>{{ selectedPackage.name }}</h5>
                            <p class="package-desc">{{ selectedPackage.description }}</p>
                            <div class="package-items">
                                <p style="color: rgba(255, 255, 255, 0.8);font-size: 14px;">包含 {{
                                    selectedPackage.items.length }} 件商品</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 收件人信息 -->
                <div class="recipient-info" v-if="recipient">
                    <h4 style="color: white;margin: 20px 0 10px;">收件人信息</h4>
                    <div class="info-item">
                        <span class="label">姓名：</span>
                        <span class="value">{{ recipient.recipient }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">电话：</span>
                        <span class="value">{{ recipient.mobile }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">地址：</span>
                        <span class="value">{{ recipient.address }}</span>
                    </div>
                </div>

                <div style="margin: 30px 16px 16px;">
                    <van-button round block style="background: rgb(255, 220, 46);border: none;font-weight: bold;"
                        @click="goBack">返回继续下单</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vant';

export default {
    name: 'SuccessPage',
    props: {
        msg: String
    },
    components: {
        VanIcon: Icon
    },
    data() {
        return {
            selectedPackage: null,
            recipient: null
        };
    },
    mounted() {
        // 从localStorage获取订单信息f
        const orderInfo = localStorage.getItem('orderInfo');
        if (orderInfo) {
            const parsedInfo = JSON.parse(orderInfo);
            this.selectedPackage = parsedInfo.packageObj;
            this.recipient = { ...parsedInfo };
        }
    },
    methods: {
        goBack() {
            this.$router.push('/gifts');
        }
    }
}
</script>

<style scoped>
.success-container {
    text-align: left;
    background-color: #0ba5a5e8;
    height: 100vh;
}

.form-ct {
    padding: 14px 0;
    /* background: #e9ad2def; */
    /* min-height: 100vh; */
}

.form {
    padding: 14px;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 8px;
    /* background: rgba(100, 225, 100, 0.3); */
    /* 棕色系半透明背景 */
}

.success-message {
    text-align: center;
    margin: 30px 0;
}

.selected-package {
    margin: 20px 0;
}

.package-info {
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    padding: 15px;
    border-radius: 8px;
}

.package-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 15px;
}

.package-details {
    flex: 1;
}

.package-details h5 {
    color: white;
    margin: 0 0 5px 0;
    font-size: 16px;
}

.package-desc {
    color: rgba(255, 255, 255, 0.8);
    margin: 0 0 10px 0;
    font-size: 14px;
}

.recipient-info {
    margin: 20px 0;
}

.info-item {
    display: flex;
    margin: 10px 0;
    background: rgba(255, 255, 255, 0.1);
    padding: 10px;
    border-radius: 4px;
}

.label {
    color: white;
    font-weight: 600;
    width: 60px;
}

.value {
    color: rgba(255, 255, 255, 0.8);
    flex: 1;
}
</style>